import { Steps as SharedSteps, Step } from '@components'

import { useTranslation } from 'react-i18next'

export const Steps = () => {
  const { t } = useTranslation()

  const steps: Step[] = [
    {
      number: 1,
      description: 'skat_form.disconnect.steps.select_ageras_description',
      header: t('skat_form.disconnect.steps.select_ageras_header'),
    },
    {
      number: 2,
      description: 'skat_form.disconnect.steps.click_remove_description',
      header: t('skat_form.disconnect.steps.click_remove_header'),
    },
  ]

  return <SharedSteps steps={steps} />
}
